export const RENTAL_CAR_SCHEDULE_TYPE_RENTAL = "대여";
export const RENTAL_CAR_SCHEDULE_TYPE_OPERATION = "운행";
export const RENTAL_CAR_SCHEDULE_TYPE_TRUCK = "트럭";

export const buildRentalCarShareUrl = (shareToken) => {
	if (typeof window === "undefined" || !shareToken) {
		return "";
	}
	return `${window.location.origin}/utils/rent-cars/share/${shareToken}`;
};

export const copyRentalCarShareUrl = async (shareToken) => {
	const url = buildRentalCarShareUrl(shareToken);
	if (!url) {
		throw new Error("공유 링크를 생성할 수 없습니다.");
	}
	if (navigator.clipboard?.writeText) {
		await navigator.clipboard.writeText(url);
		return url;
	}
	const textarea = document.createElement("textarea");
	textarea.value = url;
	textarea.setAttribute("readonly", "");
	textarea.style.position = "absolute";
	textarea.style.left = "-9999px";
	document.body.appendChild(textarea);
	textarea.select();
	document.execCommand("copy");
	document.body.removeChild(textarea);
	return url;
};
